import React, { useEffect, useState } from 'react';
export const eVideo = valor => /\.(mp4|mov|m4v|webm|3gp)$/i.test(valor || '');
export const MAX_VIDEO_BYTES = 100 * 1024 * 1024;
export function pedidoComVideos(payload, videos) {
    if (!videos.length) return payload;
    const form = new FormData();
    form.append('payload', JSON.stringify(payload));
    videos.forEach(file => form.append('videos', file, file.name));
    return form;
}
export default function ManutencaoEvidencia({ src, file, alt, style }) {
    const [preview, setPreview] = useState('');
    useEffect(() => {
        if (!file) return undefined;
        const url = URL.createObjectURL(file);
        setPreview(url);
        return () => URL.revokeObjectURL(url);
    }, [file]);
    const url = file ? preview : src;
    if (file || eVideo(src)) return <div style={{ width: 180, maxWidth: '100%' }}>
        <video src={url || undefined} controls playsInline preload="metadata" aria-label={alt}
            style={{ ...style, width: '100%', height: 110, background: '#172b3a' }} />
        {url && <a href={url} target="_blank" rel="noreferrer" style={{ display: 'block', fontSize: 12 }}>Abrir vídeo</a>}
    </div>;
    return <img src={url} alt={alt} style={style} />;
}
